import React from "react"
import { injectIntl, FormattedMessage } from "react-intl"

import IntlProps, { Intl } from "../../state/helpers/IntlProps"
import { INVENTORY_RULE_KEY, LIMIT_RULE_KEY, NULL_RULE_KEY } from "../../state/price-list/ruleStrategyKeys"

import { getPriceListName } from "../../name-helpers/priceListNameHelper"

type OwnProps = {
    ruleKey: string
}
const PriceListValidationRuleInfoComponent = (props: OwnProps & IntlProps) => {
    return (
        <>
            {getRuleInfo(props.ruleKey, props.intl)}
        </>
    )
}

const getRuleInfo = (ruleKey: string, intl: Intl) => {
    let lines: JSX.Element[]
    switch (ruleKey) {
    case INVENTORY_RULE_KEY:
        lines = getInventoryRuleLines(intl)
        break
    case LIMIT_RULE_KEY:
        lines = getLimitRuleLines(intl)
        break
    case NULL_RULE_KEY:
    default:
        lines = getNullRuleLines(intl)
        break
    }
    return (
        <span>
            {lines.map(x => <>{x}<br /></>)}
        </span>
    )
}

const getLimitRuleLines = (intl) => {
    return [
        <FormattedMessage
            key='price_list.edit_validation_rules.limit_key.limit_line_item_information_line_1'
            id='price_list.edit_validation_rules.limit_key.limit_line_item_information_line_1'
            defaultMessage="Limit product quantity available for a line item"
        />,
        <FormattedMessage
            key='price_list.edit_validation_rules.limit_key.limit_line_item.information_line_2'
            id='price_list.edit_validation_rules.limit_key.limit_line_item.information_line_2'
            defaultMessage={"A line item will be disabled if it's requested quantity " +
                "plus it's aggregated sold quantity would surpass it's limit"}
        />,
        <FormattedMessage
            key='price_list.edit_validation_rules.limit_key.limit_line_item.info_line_4'
            id='price_list.edit_validation_rules.limit_key.limit_line_item.info_line_4'
            defaultMessage={"A line item is automatically disabled if the limit " +
                "for that line or the {priceList} max capacity is hit"}
            values={{
                priceList: getPriceListName(intl)
            }}
        />,

        <FormattedMessage
            key={"price_list.edit_validation_rules.disabled_row.info"}
            id={"price_list.edit_validation_rules.disabled_row.info"}
            defaultMessage={"The {priceList} will be disabled when atleast one requierd line item is disabled"}
            values={{
                priceList: getPriceListName(intl)
            }}
        />
    ]
}

const getInventoryRuleLines = (intl) => {
    return [
        <FormattedMessage
            key='price_list.edit_validation_rules.inventory_key.information'
            id='price_list.edit_validation_rules.inventory_key.information'
            defaultMessage="A line item will be disabled if there's currently not enough stock to fulfill the requested quantity"
        />,

        <FormattedMessage
            key={"price_list.edit_validation_rules.disabled_row.info"}
            id={"price_list.edit_validation_rules.disabled_row.info"}
            defaultMessage={"The {priceList} will be disabled when atleast one requierd line item is disabled"}
            values={{
                priceList: getPriceListName(intl)
            }}
        />
    ]
}

const getNullRuleLines = (intl) => {
    return [
        <FormattedMessage
            key='price_list.edit_validation_rules.none_key.info'
            id='price_list.edit_validation_rules.none_key.info'
            defaultMessage='No dynamic rules will be applied to your {priceList}'
            values={{
                priceList: getPriceListName(intl)
            }}
        />
    ]
}

export default injectIntl(PriceListValidationRuleInfoComponent)


// WEBPACK FOOTER //
// ./src/price-list/components/PriceListValidationRuleInfoComponent.tsx